import React from "react";
import { BiLinkExternal } from "react-icons/bi";
import { GoMarkGithub } from "react-icons/go";
import { IconContext } from "react-icons";
import {
  LinkName,
  ProjectCard,
  ProjectCodeLink,
  ProjectDetails,
  ProjectImage,
  ProjectLiveLink,
  ProjectsContainer,
  ProjectTitle,
  ProjectTransitionImage,
} from "../styles/Projects.styled";

const ProjectCardComponent = ({
  image,
  transitionImage,
  title,
  codeLink,
  liveLink,
  tech,desc
}) => {
  return (
    <>
      <IconContext.Provider value={{ size: "1rem" }}>
        {/* <ProjectCard>
          <ProjectImage src={image} alt={title} />
          <ProjectTransitionImage src={transitionImage} alt={title} />
          <ProjectDetails>
            <ProjectTitle>{title}</ProjectTitle>
            <ProjectsContainer>
              Tech Stack : {tech}
            </ProjectsContainer>
            <ProjectsContainer>
             Description :{desc}
            </ProjectsContainer>
            <ProjectCodeLink
              href={codeLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <GoMarkGithub />
              <LinkName>Github Code</LinkName>
            </ProjectCodeLink>
            <ProjectLiveLink
              href={liveLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <BiLinkExternal />
              <LinkName>Live</LinkName>
            </ProjectLiveLink>
          </ProjectDetails>
        </ProjectCard> */}

       <div style={{display:'flex',width:'40%',flexDirection:'column'}}>
       <img src={image}  alt='image1' style={{width:'100%',height:300,boxShadow:'0 10px 10px rgb(0 0 0 / 0.2)'}} />
       <div>
       <ProjectsContainer>
              Tech Stack : {tech}
            </ProjectsContainer>
            <ProjectsContainer>
             Description :{desc}
            </ProjectsContainer>
           <div style={{display:'flex',justifyContent:'space-between',marginTop:10}}>
            <a style={{display:'flex',justifyContent:'space-around',width:'25%',alignItems:'center'}}
            href={codeLink}
            target="_blank"
            rel="noopener noreferrer"
            >
             
            <GoMarkGithub />
            <div>Github</div>
          
            </a>
           
             <a style={{display:'flex',justifyContent:'space-around',width:'25%',alignItems:'center'}}
               href={liveLink}
               target="_blank"
               rel="noopener noreferrer"
             
             >
            
              <BiLinkExternal />
              <div>Live Link</div>
             </a>
            
            </div>
       </div>
       </div>
      </IconContext.Provider>
    </>
  );
};

export default ProjectCardComponent;
